<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Corporations</h1>
        </div>
        <div class="float-left">
            <el-button
                @click="create"
                type="primary"
                v-if="can(Permissions.CREATE_CORPORATION)"
                ><i class="mdi mdi-plus"></i> Create
            </el-button>
            <el-input
                placeholder="Search Corporations..."
                style="width: 250px"
                v-model="filter.search"
            />
        </div>
        <div class="clearfix"></div>
        <el-table row-key="id" :data="paginatedData">
            <el-table-column prop="name" label="Name"></el-table-column>
            <el-table-column prop="location.city" label="City and State">
                <template slot-scope="{ row }" v-if="row.location">
                    {{ row.location.city }}, {{ row.location.state }}
                </template>
            </el-table-column>
            <el-table-column prop="logo" label="Logo">
                <template slot-scope="scope">
                    <img
                        v-if="scope.row.logo"
                        :src="scope.row.logo.url"
                        width="100"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="actions" width="260px">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button
                            @click="editItem(scope.row)"
                            icon="mdi mdi-pencil"
                            v-if="can(Permissions.EDIT_CORPORATION)"
                            >Edit
                        </el-button>
                        <el-button
                            @click="login(scope.row)"
                            icon="mdi mdi-login"
                            class="el-button--corwin-green"
                            >Login
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="mt-10" v-if="pageCount >= 1">
            <el-pagination
                class="pull-right"
                v-if="pagination && pageCount > 1"
                background
                :page-size="pagination.per_page"
                :current-page.sync="pagination.current_page"
                :total="dataCount"
                @current-change="changePage"
                @size-change="handleSizeChange"
            >
            </el-pagination>
            <div class="clearfix"></div>
        </div>
        <el-dialog
            :title="editingItem ? 'Edit Corporation' : 'Create Corporation'"
            :visible.sync="dialogVisible"
            width="500px"
        >
            <el-form @submit.prevent="submit()">
                <el-form-item required label="Name" :class="form.state('name')">
                    <el-input
                        v-model="form.name"
                        name="name"
                        v-validate="'required'"
                    />
                    <form-feedback :form="form" field="name" />
                </el-form-item>
                <el-form-item
                    required
                    label="Subdomain"
                    :class="form.state('slug')"
                >
                    <el-input
                        v-model="form.slug"
                        name="slug"
                        v-validate="'required'"
                    />
                    <form-feedback :form="form" field="slug" />
                </el-form-item>
                <el-form-item
                    required
                    label="Payment Type"
                    :class="form.state('payment_type')"
                >
                    <br />
                    <el-radio-group
                        v-model="form.payment_type"
                        name="payment_type"
                        data-vv-as="payment type"
                        v-validate="'required'"
                    >
                        <el-radio :label="PaymentTypes.IMMEDIATE"
                            >Immediate</el-radio
                        >
                        <el-radio :label="PaymentTypes.BILL_TO_ACCOUNT"
                            >Bill to Account</el-radio
                        >
                    </el-radio-group>
                    <form-feedback :form="form" field="payment_type" />
                </el-form-item>
                <el-form-item label="Logo" :class="form.state('logo')">
                    <br />
                    <img v-if="logo_src" :src="logo_src" style="width: 200px" />
                    <br />
                    <input
                        @change="onChangeLogo"
                        type="file"
                        style="display: none"
                        ref="inputLogo"
                        accept="image/*"
                    />
                    <el-button
                        icon="mdi mdi-camera"
                        @click="$refs.inputLogo.click()"
                        >Upload Logo</el-button
                    >
                    <form-feedback :form="form" field="logo" />
                </el-form-item>
                <el-form-item
                    required
                    label="Street"
                    :class="form.state('location.street')"
                >
                    <el-input
                        v-validate="'required'"
                        name="location.street"
                        data-vv-as="street"
                        v-model="form.location.street"
                    />
                    <form-feedback :form="form" field="location.street" />
                </el-form-item>
                <el-form-item
                    required
                    label="City"
                    :class="form.state('location.city')"
                >
                    <el-input
                        v-validate="'required'"
                        name="location.city"
                        data-vv-as="city"
                        v-model="form.location.city"
                    />
                    <form-feedback :form="form" field="location.city" />
                </el-form-item>
                <el-form-item
                    required
                    label="State"
                    :class="form.state('location.state')"
                >
                    <el-input
                        v-validate="'required'"
                        name="location.state"
                        data-vv-as="state"
                        v-model="form.location.state"
                    />
                    <form-feedback :form="form" field="location.state" />
                </el-form-item>
                <el-form-item
                    required
                    label="Zip"
                    :class="form.state('location.zip')"
                >
                    <el-input
                        v-validate="'required'"
                        name="location.zip"
                        data-vv-as="zip"
                        v-model="form.location.zip"
                    />
                    <form-feedback :form="form" field="location.zip" />
                </el-form-item>
                <h3>Discounts</h3>
                <span class="text-small">
                    Enter all discounts as decimals up to 2 places, ex: enter 2%
                    as 0.02.
                </span>
                <table style="width: 100%">
                    <tbody>
                        <tr v-for="(discount, index) in form.discounts">
                            <td style="width: 260px">
                                <template v-if="!discount.discount_id">
                                    <el-form-item
                                        class="mb-0"
                                        :class="
                                            form.state(`discount.${index}.name`)
                                        "
                                    >
                                        <el-input
                                            v-validate="'required'"
                                            data-vv-as="discount name"
                                            :name="`discount.${index}.name`"
                                            placeholder="Discount Name..."
                                            v-model="discount.name"
                                        />
                                        <form-feedback
                                            :form="form"
                                            :field="`discount.${index}.name`"
                                        />
                                    </el-form-item>
                                </template>
                                <span v-else>{{ discount.name }}</span>
                            </td>
                            <td>
                                <el-form-item
                                    class="mb-0"
                                    :class="
                                        form.state(`discount.${index}.value`)
                                    "
                                >
                                    <el-input
                                        v-validate="'required'"
                                        data-vv-as="discount value"
                                        :name="`discount.${index}.value`"
                                        placeholder="Discount in decimal..."
                                        type="number"
                                        step="0.01"
                                        max="0.99"
                                        min="0.01"
                                        v-model.number="discount.value"
                                    />
                                    <form-feedback
                                        :form="form"
                                        :field="`discount.${index}.value`"
                                    />
                                </el-form-item>
                            </td>
                            <td style="width: 50px">
                                <el-button
                                    type="danger"
                                    size="mini"
                                    icon="mdi mdi-close"
                                    title="Remove"
                                    @click="removeDiscount(discount)"
                                ></el-button>
                            </td>
                        </tr>
                        <tr v-if="form.discounts.length">
                            <td class="bold text-right" colspan="2">
                                Total Discount: {{ totalDiscount }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="mt-10">
                    <el-select
                        style="width: auto"
                        v-model="discountForm.discount_id"
                    >
                        <el-option
                            label="New Discount..."
                            :value="null"
                        ></el-option>
                        <el-option-group
                            label="Existing Discounts"
                            v-if="availableDiscounts.length"
                        >
                            <el-option
                                :key="index"
                                v-for="(discount, index) in availableDiscounts"
                                :label="discount.name"
                                :value="discount.id"
                            ></el-option>
                        </el-option-group>
                    </el-select>
                    <el-button
                        type="primary"
                        icon="mdi mdi-plus"
                        @click="addDiscount()"
                        >Add</el-button
                    >
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" :disabled="form.busy"
                    >Cancel</el-button
                >
                <el-button
                    type="primary"
                    icon="mdi mdi-content-save"
                    @click="submit"
                    :loading="form.busy"
                    >Save
                </el-button>
            </div>
        </el-dialog>
    </vue-scroll>
</template>

<script>
import { mapState } from "vuex";
import * as Mutations from "@/store/constants/mutations";
import paginator from "@/mixins/frontend-paginator";
import * as PaymentTypes from "@/constants/payment-types";
import * as Actions from "@/store/constants/actions";
import * as Routes from "@/constants/routes";
import auth from "@/mixins/auth";
import community_mixin from "@/mixins/community";

export default {
    mixins: [community_mixin, paginator, auth],
    data() {
        return {
            PaymentTypes,
            dialogVisible: false,
            form: new Form({
                name: null,
                slug: null,
                logo: null,
                payment_type: PaymentTypes.IMMEDIATE,
                location: {
                    street: null,
                    city: null,
                    state: null,
                    zip: null,
                },
                discounts: [],
            }),
            discountForm: {
                discount_id: null,
            },
            logo_src: null,
            editingItem: null,
            dataKey: "filteredCorporations",
            filter: {
                search: "",
            },
        };
    },
    computed: {
        ...mapState(["corporations"]),
        ...mapState({
            discounts: (state) => state.discounts.data,
        }),
        availableDiscounts() {
            return this.discounts.filter((item) => {
                return !_.includes(
                    _.map(this.form.discounts, (i) => i.discount_id),
                    item.id
                );
            });
        },
        totalDiscount() {
            let discount = _.sumBy(this.form.discounts, (item) =>
                item.value ? item.value : 0
            );
            if (!discount) {
                return 0;
            }
            return discount.toFixed(2);
        },
        filteredCorporations() {
            return this.corporations.data.filter((corporation) => {
                if (!window.Utils.emptyOrNull(this.filter.search)) {
                    return (
                        (corporation.name &&
                            corporation.name
                                .toLowerCase()
                                .includes(this.filter.search.toLowerCase())) ||
                        corporation.slug
                            .toLowerCase()
                            .includes(this.filter.search.toLowerCase())
                    );
                }
                return true;
            });
        },
    },
    mounted() {
        this.form.setVeeErrors(this.veeErrors);
    },
    methods: {
        create() {
            this.$router.push({
                name: Routes.CREATE_CORPORATION,
            });
        },
        onChangeLogo(e) {
            window.Utils.getFileImageData(e.currentTarget).then((response) => {
                this.logo_src = response;
                this.form.logo = e.target.files[0];
            });
        },
        addDiscount() {
            let discount;
            if (this.discountForm.discount_id) {
                let discount = this.discounts.find(
                    (item) => item.id === this.discountForm.discount_id
                );
                this.form.discounts.push({
                    discount_id: discount.id,
                    name: discount.name,
                    value: discount.default_value,
                });
            } else {
                discount = null;
                this.form.discounts.push({
                    discount_id: null,
                    name: null,
                    value: null,
                });
            }
            this.discountForm.discount_id = null;
        },
        removeDiscount(discount) {
            window.Utils.arrayDelete(this.form.discounts, discount);
        },
        submit() {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    return;
                }
                if (this.editingItem) {
                    window.App.putData(
                        `/web-api/corporation/${this.editingItem.id}?include=${this.corporations.meta.include}`,
                        this.form
                    )
                        .then((response) => {
                            this.dialogVisible = false;
                            this.$notify.success({
                                message: `Changes have been saved`,
                            });
                            this.$store.commit(
                                Mutations.UPDATE_CORPORATION,
                                response.data
                            );
                        })
                        .finally(() =>
                            this.$store.dispatch(Actions.FETCH_DISCOUNTS)
                        );
                } else {
                    window.App.postData(
                        `/web-api/corporation?include=${this.corporations.meta.include}`,
                        this.form
                    )
                        .then((response) => {
                            this.dialogVisible = false;
                            this.$notify.success({
                                message: `New corporation has been saved.`,
                            });
                            this.$store.commit(
                                Mutations.NEW_CORPORATION,
                                response.data
                            );
                        })
                        .finally(() =>
                            this.$store.dispatch(Actions.FETCH_DISCOUNTS)
                        );
                }
            });
        },
        editItem(item) {
            this.$router.push({
                name: Routes.EDIT_CORPORATION,
                params: {
                    id: item.id,
                },
            });
        },
        login(item) {
            window.open(`${this.getCommunityBaseUrl(item)}/home`, "_blank");
        },
    },
};
</script>

<style scoped></style>
